<div class="relative flex flex-col w-full h-full">
    <!-- Header -->
    <div class="flex flex-0 shrink-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <!-- Icon + Title -->
        <div class="flex items-center gap-3">
            <ng-container *ngIf="data?.icon?.show">
                <mat-icon
                    class="text-on-primary"
                    [svgIcon]="data.icon?.name!"
                ></mat-icon>
            </ng-container>
            <ng-container *ngIf="data?.title">
                <div class="text-lg font-medium text-on-primary" [innerHTML]="data.title"></div>
            </ng-container>
        </div>

        <!-- Dismiss button -->
        <ng-container *ngIf="data.dismissible">
            <button mat-icon-button [matDialogClose]="undefined">
                <mat-icon
                    class="text-on-primary"
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>
        </ng-container>
    </div>

    <!-- Message -->
    <div class="flex flex-row w-full p-4 pb-8">
        <ng-container *ngIf="data?.message">
            <div
                class="text-secondary text-left text-lg"
                [innerHTML]="data.message"
            ></div>
        </ng-container>
    </div>

    <!-- Actions -->
    <ng-container *ngIf="data.actions?.confirm?.show || data.actions?.cancel?.show">
        <div
            class="flex items-center justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10"
        >
            <!-- Cancel -->
            <ng-container *ngIf="data.actions?.cancel?.show">
                <button mat-stroked-button [matDialogClose]="'cancelled'">
                    {{ data.actions?.cancel?.label }}
                </button>
            </ng-container>

            <!-- Confirm -->
            <ng-container *ngIf="data.actions?.confirm?.show">
                <button
                    mat-flat-button
                    [color]="data.actions?.confirm?.color"
                    [matDialogClose]="'confirmed'"
                >
                    {{ data.actions?.confirm?.label }}
                </button>
            </ng-container>
        </div>
    </ng-container>
</div>
